export default {
  massRemove: 'Remove flapping rules',
  massEnable: 'Enable flapping rules',
  massDisable: 'Disable flapping rules',
};
